import * as React from "react"
import type { SVGProps } from "react"
const SvgPencilWrite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12.48 17.54 8.37-8.38-1.3-1.3-8.37 8.38zM3 15.99q0 .72.5 1.12t1.65.53a1 1 0 0 1 .64.36q.24.32.21.71a1 1 0 0 1-.3.7.8.8 0 0 1-.67.23A5.4 5.4 0 0 1 2 18.48a3.2 3.2 0 0 1-1-2.5q0-1.6 1.34-2.63a7 7 0 0 1 3.71-1.21 4 4 0 0 0 1.46-.31q.5-.24.49-.67 0-.54-.52-.86a5 5 0 0 0-1.73-.49 1 1 0 0 1-.64-.37 1 1 0 0 1-.18-.73 1 1 0 0 1 .35-.68 1 1 0 0 1 .7-.22q2.07.3 3.05 1.12.97.8.97 2.23 0 1.33-.96 2.08t-2.84.9a6 6 0 0 0-2.4.59q-.8.46-.8 1.26m9.95 3.9-4.12-4.13 9.55-9.55q.5-.5 1.18-.5.7 0 1.19.5l1.75 1.75q.5.5.5 1.2 0 .68-.5 1.18zm-3.97.82a.8.8 0 0 1-.76-.22.8.8 0 0 1-.22-.75l.83-3.98 4.12 4.13z" />
  </svg>
)
export default SvgPencilWrite
